// featureFlags.js
//
// Single switch for the "Systems" area (meeting 8-Oct-2026: "Hide Systems for
// v1.0 unless it is ready... full multi-system support can move to v2.0").
//
// false  -> the "Systems" left-menu entry and the Dashboard "Reaction Systems"
//           card are hidden. Saved runs stay reachable through "Reports"
//           (Run History), and "Reopen" there still reloads a saved run's
//           inputs into Data Fitting Input.
// true   -> v2.0 behaviour (Systems menu entry + Dashboard card).
//
// If you also want direct URL access closed while this is false, guard the
// /systems route in App.js:
//   {SYSTEMS_ENABLED && <Route path="/systems" element={<SystemsPage />} />}
export const SYSTEMS_ENABLED = false;
